/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Associated_With_GatewayInputs */



/**
* | output |
* | --- |
* | "This gateway is associated with a module" |
*
* @param {Module_Associated_With_GatewayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_associated_with_gateway = /** @type {((inputs?: Module_Associated_With_GatewayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Associated_With_GatewayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("This gateway is associated with a module")
	return /** @type {LocalizedString} */ ("Cette box est associée à un module")
});